var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie-box"},[_c('div',{staticClass:"pie-flx"},[(_vm.data.rows.length)?[_c('Vchart',{attrs:{"option":_vm.echartData}})]:[_c('emptyTip')]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }